import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import ConsentListContext from './Context/ConsentContext';
import StepperContext from './Context/StepperContext';
import AuthApis from '../hepler/authApis.service';
import { toast } from 'react-toastify';
import RequestedConsents from './paymentConsent/RequestedConsents';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import LinkedAccountsSection from './Accounts/LinkedAccountsSection';
// import ConsentCard from './paymentConsent/ConsentCard';
import ConsentCardFull from './paymentConsent/ConsentCardFull/ConsentCardFull';
import linkedAccountsSectionStyles from './Accounts/LinkedAccountsSection.styles';
import DialogBox from './Dialog Box/Dialog Box';
import WhyShare from './Sections/WhyShare';
import DenyConsent from './Accounts/DenyConsent';
import { areAllArraysEmptyForConsents } from '../hepler/functions';
import FloatingButton from './Fab/FloatingButton';
import Drawer from './Drawer/Drawer';
import FiuList from './paymentConsent/FiuList';
import {
	isAccountLinked,
	showSelectButton,
	filterAccountsByRestrictions,
	fipExclusionFilter,
	getUniqueKey,
} from '../utils/helper.utils';
import { postMessage } from '../utils/common.utils';
import {
	filterLinkedAccountsByRestrictions,
	filterSelectedAccountsByRestrictions,
	areAllMandatoryRestrictionsSatisfied,
} from '../utils/targetedAccounts.utils';
import {
	startConsentView,
	captureConsentApproved,
	captureConsentDenied,
	captureConsentPageLoaded,
} from '../utils/analytics/posthog.utils';
import {
	computeAccountRestrictions,
	filterRestrictedAccounts,
	removeRestrictedAccountsFromSelection,
	isAccountRestrictedForConsent,
	calculateAccountBlockingMetrics,
} from '../utils/accountRestrictions.utils';
import { useTranslation } from '../hooks/useTranslation';

function PaymentConsent(props) {
	const { t } = useTranslation();
	const fipExclusionFromJourney = global?.sdkOptions?.fipExclusionFromJourney;
	const consentsContext = useContext(ConsentListContext);
	const { prevStep } = useContext(StepperContext);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const consentsAll = consentsContext.consentList;
	const consentsAccepted = consentsContext.acceptedConsentsMultiConsent;
	const consentsDenied = consentsContext.deniedConsentsMultiConsent;
	const [state, setState] = useState({
		linkedAccounts: [], // Filtered for display
		allLinkedAccounts: [], // Unfiltered for validation
		matchedRestrictions: [], // Only restrictions that were actually discovered
		selectedAccounts: [],
		consentDetailsList: consentsContext?.consentList,
		isDisable: false,
		consentSelectedAccounts: {},
		uniqueLinkedAccounts: [],
	});
	const [showSelectAll, setShowSelectAll] = useState(true);
	const [selectAll, setSelectAll] = useState(
		consentsAll.length === consentsContext?.selectedConsents.length
	);
	const [openDrawer, setOpenDrawer] = useState(false);

	// State to track whether any info icon was clicked
	const [isPurposeIconClicked, setIsPurposeIconClicked] = useState(false);
	const [isAccountInfoIconClicked, setIsAccountInfoIconClicked] =
		useState(false);

	// State to track if consent page loaded analytics has been fired
	const [hasConsentPageAnalyticsFired, setHasConsentPageAnalyticsFired] =
		useState(false);

	const handleInfoClick = (iconType) => {
		if (iconType === 'purpose') setIsPurposeIconClicked(true);
		if (iconType === 'accountInfo') setIsAccountInfoIconClicked(true);
	};

	// Function to calculate account blocking metrics and trigger analytics
	const triggerConsentPageAnalytics = (linkedAccounts) => {
		if (
			hasConsentPageAnalyticsFired ||
			!linkedAccounts ||
			linkedAccounts.length === 0
		) {
			return;
		}

		// Calculate analytics metrics using utility function
		const analyticsMetrics = calculateAccountBlockingMetrics(
			linkedAccounts,
			consentsAll
		);

		// Trigger analytics event
		captureConsentPageLoaded(analyticsMetrics);

		// Mark analytics as fired
		setHasConsentPageAnalyticsFired(true);
	};

	// console.log('State: ', state);
	const authApis = new AuthApis();
	const SUBMITTING_CONSENT_COUNTER =
		consentsAll.length > 1 && global.institutionType !== 'LSP' ? 1000 : 0;

	//New
	const getMatchingConsents = (consent, options) => {
		for (const option of options) {
			if (option['Purpose.code'] == consent?.Purpose?.code) {
				if (!option.checkbox || option.defaultCheck) {
					return consent?.ConsentHandle;
				}
			}
		}
		return '';
	};

	// Moved to targetedAccounts.utils.js

	const [selectedConsentsState, setSelectedConsentsState] = useState(
		consentsContext?.selectedConsents.map((a) => {
			if (
				consentsAll.length > 1 &&
				global.consentOptions &&
				global.institutionType !== 'LSP'
			) {
				return getMatchingConsents(a, global.consentOptions);
			}
			return a?.ConsentHandle;
		})
	);

	useEffect(() => {
		if (
			consentsAll.length > 1 &&
			global.consentOptions &&
			global.institutionType !== 'LSP'
		) {
			consentsContext.updateSelectedConsentList(
				consentsAll.filter((x) =>
					selectedConsentsState.includes(x.ConsentHandle)
				)
			);
			setShowSelectAll(showSelectButton(consentsAll, global.consentOptions));
		}
	}, [selectedConsentsState]);
	const [deny, setDeny] = useState(false);

	const isAcceptDisabled = useMemo(() => {
		const activeHandles = (selectedConsentsState || []).filter(Boolean);
		// Disable if no accounts selected for any active consent
		const noAccountsSelected =
			activeHandles.length === 0 ||
			areAllArraysEmptyForConsents(
				state.consentSelectedAccounts,
				activeHandles
			);
		if (noAccountsSelected) return true;

		// In multi-consent journeys, ensure mandatory consents have at least one account selected
		if (consentsAll.length > 1 && Array.isArray(global.consentOptions)) {
			const mandatoryPurposeCodes = new Set(
				global.consentOptions
					.filter((opt) => !opt.checkbox)
					.map((opt) => String(opt['Purpose.code']))
			);
			const mandatoryHandles = consentsAll
				.filter((c) => mandatoryPurposeCodes.has(String(c?.Purpose?.code)))
				.map((c) => c.ConsentHandle);

			const mandatoryActive = mandatoryHandles.filter((h) =>
				activeHandles.includes(h)
			);
			if (mandatoryActive.length > 0) {
				const hasMissing = mandatoryActive.some(
					(h) =>
						!Array.isArray(state.consentSelectedAccounts[h]) ||
						state.consentSelectedAccounts[h].length === 0
				);
				if (hasMissing) return true;
			}
		}
		return false;
	}, [selectedConsentsState, state.consentSelectedAccounts, consentsAll]);

	const handleClose = (event, reason) => {
		// if (reason && reason === 'backdropClick') {
		// 	return;
		// }
		setDeny(false);
	};
	// consent checkout page
	const selectUnselectConsents = (consent) => {
		setSelectedConsentsState((prevConsents) => {
			if (prevConsents.includes(consent)) {
				const index = prevConsents.indexOf(consent);
				prevConsents.splice(index, 1);
			} else {
				prevConsents.push(consent);
			}
			consentsContext.updateSelectedConsentList(
				consentsAll.filter((x) => prevConsents.includes(x.ConsentHandle))
			);
			if (prevConsents.length < consentsAll.length) {
				setSelectAll(false);
			} else {
				setSelectAll(true);
			}

			return [...prevConsents];
		});
	};

	useEffect(() => {
		// Start tracking consent view time when component mounts
		startConsentView();
		
		// Clear userClickedAddMore ONLY if in targeted account mode:
		// 1. No new discovery data (user clicked back)
		// 2. userClickedAddMore is set (user clicked "Add More")
		// 3. isAddAccount flag is set (user is in "Add Account" mode)
		
		// Only clear if user is in "Add Account" mode and came back without discovering
		// BUT: If user has already completed Add More flow once, keep showing all accounts
		if (global.redirectAccountRestrictions && !props?.location?.state?.data?.length && global.userClickedAddMore && global.isAddAccount) {
			// Check if user has completed Add More discovery at least once
			if (!global.hasCompletedAddMoreFlow) {
				// First time clicking Add More without completing - revert to restricted view
				delete global.userClickedAddMore;
				delete global.isAddAccount;
				global.isTargetedDiscoveryMode = true;
			} else {
				// User has already completed Add More flow before - keep showing all accounts
				delete global.isAddAccount; // Just clear the temporary flag
			}
		} else if (global.redirectAccountRestrictions && props?.location?.state?.data?.length && global.isAddAccount) {
		// User discovered accounts via Add More - mark flow as completed
		global.hasCompletedAddMoreFlow = true;
		delete global.isAddAccount;
	}

	if (props?.location?.state?.data?.length) {
		const data = props.location.state.data;
		
		const shouldFilter =
			!!fipExclusionFromJourney && fipExclusionFromJourney.length > 0;

			const filteredData = shouldFilter ? fipExclusionFilter(data) : data;
			
			// Extract matched restrictions from discovered accounts
			const matchedRestrictions = [];
			
			if (global.redirectAccountRestrictions) {
				filteredData.forEach(account => {
					// Try to find matching restriction by comparing last 4 digits
					const matchingRestriction = global.redirectAccountRestrictions.find(
						(restriction) => {
							const fipIdMatch = account.fipId === restriction.fipId;
							const fiTypeMatch = account.FIType === restriction.fiType;
							const accTypeMatch = account.accType === restriction.accType;
							// Compare last 4 digits: restriction might have just "6086" while account has "XXXXX6086"
							const maskedMatch = account.maskedAccNumber === restriction.maskedAccNumber || 
							                   account.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
							return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
						}
					);
					
					if (matchingRestriction) {
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: matchingRestriction.restrictions
						});
					} else if (account.restrictions) {
						// If account already has restrictions attached, use them
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: account.restrictions
						});
					}
				});
			}

			// Check if there are linked accounts but none match the provided AccType and FIType
			if (
				(global?.accountRestrictions &&
					filterAccountsByRestrictions(filteredData).length === 0) ||
				filteredData.length === 0
			) {
				props.updateLoader(true);
				toast.error(t('paymentConsent.error.noRelevantAccLinked'));
				setTimeout(() => {
					props.history.push(
						`/home/?number=${global.mobileNumber}&isAddAccount=true&isNewUser=true`
					);
					props.updateLoader(false);
					prevStep();
				}, 0);
				return;
			}

	// Filter accounts to display based on restrictions
	const linkedAccountsToDisplay = (global.redirectAccountRestrictions && !global.userClickedAddMore)
		? filteredData.filter(acc => 
			global.redirectAccountRestrictions.some(restriction => {
				const fipIdMatch = acc.fipId === restriction.fipId;
				const fiTypeMatch = acc.FIType === restriction.fiType;
				const accTypeMatch = acc.accType === restriction.accType;
				const maskedMatch = acc.maskedAccNumber === restriction.maskedAccNumber || 
				                   acc.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
				return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
			})
		)
		: global?.accountRestrictions
		? filterAccountsByRestrictions(filteredData)
		: filteredData;
	
	// Set consent selections
	const consentSelections = setConsentSelectedAccount(linkedAccountsToDisplay);
	
	// Filter out restricted accounts from initial selection
	const accountsWithoutRestrictions = filterRestrictedAccounts(
		linkedAccountsToDisplay,
		consentsAll
	);
	
	// Initial selection
	const accountsForSelection = (global.redirectAccountRestrictions && !global.userClickedAddMore)
		? linkedAccountsToDisplay
		: global.manualAccCheck
		? []
		: global?.accountRestrictions
		? []
		: [...accountsWithoutRestrictions];
	
	setState((prevState) => ({
		...prevState,
		allLinkedAccounts: filteredData, // Unfiltered for validation
		matchedRestrictions, // Store only matched restrictions
		linkedAccounts: linkedAccountsToDisplay,
		selectedAccounts: accountsForSelection,
		consentSelectedAccounts: consentSelections,
	}));

			// Trigger analytics after accounts are loaded from state
			triggerConsentPageAnalytics(filteredData);

			props.updateLoader(false);
		} else {
			props.updateLoader(true);
			getLinkedAcc();
		}
	}, []);

	useEffect(() => {
		const uniqueAccounts = [];
		const seenAccounts = new Set();

		state.linkedAccounts.forEach((account) => {
			const uniqueKey = getUniqueKey(account, account.fipId);
			if (!seenAccounts.has(uniqueKey)) {
				seenAccounts.add(uniqueKey);
				uniqueAccounts.push(account);
			}
		});

		setState((prevState) => ({
			...prevState,
			uniqueLinkedAccounts: uniqueAccounts,
		}));
	}, [state.linkedAccounts]);

	const setConsentSelectedAccount = (accounts) => {
		const res = {};
		for (const consent of consentsAll) {
			const restrictions = computeAccountRestrictions(consent, accounts);
			const restrictedAccountRefs = Object.keys(restrictions);

			const filteredAccounts = accounts.filter(
				(x) =>
					consent?.fiTypes.includes(x?.FIType) &&
					!restrictedAccountRefs.includes(x?.accRefNumber)
			);

		res[consent?.ConsentHandle] = global.redirectAccountRestrictions
			? [...(filteredAccounts || [])]
			: global.manualAccCheck
			? []
			: global?.accountRestrictions
			? []
			: [...(filteredAccounts || [])];
		}
		return res;
	};

	const getLinkedAcc = () => {
		authApis.getLinkedAccounts().then((res) => {
			props.updateLoader(false);
			if (res?.status === 'SUCCESS') {
				const shouldFilter =
					!!fipExclusionFromJourney && fipExclusionFromJourney.length > 0;
			const baseAccounts = global?.accountRestrictions
				? filterAccountsByRestrictions(res?.LinkedAccounts)
				: res?.LinkedAccounts;
			const filteredAccounts = shouldFilter
				? fipExclusionFilter(baseAccounts)
				: baseAccounts;
		// If redirectAccountRestrictions exists and user hasn't clicked "Add More", filter accounts
		const accountsToDisplay = (global.redirectAccountRestrictions && !global.userClickedAddMore)
			? filterLinkedAccountsByRestrictions(res?.LinkedAccounts)
			: filteredAccounts;

				// Extract matched restrictions from API response
				// API doesn't return restrictions, so manually match against global.redirectAccountRestrictions
				const matchedRestrictions = [];
			if (global.redirectAccountRestrictions) {
				filteredAccounts.forEach(account => {
					const matchingRestriction = global.redirectAccountRestrictions.find(
						(restriction) => {
							const fipIdMatch = account.fipId === restriction.fipId;
							const fiTypeMatch = account.FIType === restriction.fiType;
							const accTypeMatch = account.accType === restriction.accType;
							// Compare last 4 digits: restriction might have just "6086" while account has "XXXXX6086"
							const maskedMatch = account.maskedAccNumber === restriction.maskedAccNumber || 
							                   account.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
							return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
						}
					);
					
					if (matchingRestriction) {
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: matchingRestriction.restrictions
						});
					} else if (account.restrictions) {
						// If account already has restrictions attached, use them
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: account.restrictions
						});
					}
				});
			}

				// Check if there are linked accounts but none match the provided AccType and FIType
				if (filteredAccounts.length === 0) {
					toast.error(t('paymentConsent.error.noRelevantAccLinked'));
					props.history.push(
						`/home/?number=${
							global.mobileNumber
						}&isAddAccount=${true}&isNewUser=${true}`
					);
					prevStep();
					return;
				}

			// Additional check for targeted discovery mode
			if (
				global.redirectAccountRestrictions &&
				!global.userClickedAddMore &&
				accountsToDisplay.length === 0
			) {
				toast.error(t('paymentConsent.error.noRelevantAccLinked'));
				props.history.push(
					`/home/?number=${
						global.mobileNumber
					}&isAddAccount=${true}&isNewUser=${true}`
				);
				return;
			}

			// Filter out restricted accounts from initial selection
			const accountsWithoutRestrictions = filterRestrictedAccounts(
				accountsToDisplay,
				consentsAll
			);

		setState((prevState) => ({
			...prevState,
			allLinkedAccounts: accountsToDisplay, // Store filtered accounts
			matchedRestrictions, // Store only matched restrictions
			linkedAccounts: accountsToDisplay,
		selectedAccounts: global.redirectAccountRestrictions
			? accountsToDisplay
			: global.manualAccCheck
			? []
			: global?.accountRestrictions
			? []
			: [...accountsWithoutRestrictions],
			consentDetailsList: consentsContext.consentList,
			consentSelectedAccounts: setConsentSelectedAccount(accountsToDisplay),
		}));

				// Trigger analytics after accounts are loaded from API
				triggerConsentPageAnalytics(filteredAccounts);
			} else {
				props.updateLoader(false);
				if (global.sdkOptions?.toastMessageNoAccountLinked) {
					toast.error(t('paymentConsent.messages.toastMessageNoAccountLinked'));
				} else {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
				}
				if (res?.status === 'RECORD-NOT-FOUND') {
					props.history.push(
						`/home/?number=${
							global.mobileNumber
						}&isAddAccount=${true}&isNewUser=${true}`
					);
					prevStep();
				} else {
					if (res?.status === 'FAILURE') {
						postMessage('session', 'FAILURE');
					} else if (res?.status === 'ERROR') {
						postMessage('session', 'ERROR');
					}
					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								statusCode: 20,
							},
						});
					}, 1000);
				}
			}
		});
	};

	const updateContext = (consentHandle, status) => {
		if (status === 'ACCEPT') {
			consentsAccepted.push(consentHandle);
			consentsContext.updateAcceptedConsentsMultiConsent(consentsAccepted);
		} else {
			consentsDenied.push(consentHandle);
			consentsContext.updateDeniedConsentsMultiConsent(consentsDenied);
		}
		consentsAll.push(consentsAll.shift());
		consentsContext.updateConsentList(consentsAll);
	};
	const consentApproveRequest = async (
		accounts,
		status,
		consentHandle,
		fiuID,
		isLast
	) => {
		setState({ ...state, isDisable: true });
		await authApis
			.consentApproveRequest(accounts, status, consentHandle, fiuID)
			.then((res) => {
				if (res && res?.status === 'SUCCESS') {
					const consentStatusText =
						status === 'ACCEPT'
							? t('paymentConsent.messages.consentApproved')
							: t('paymentConsent.messages.consentDenied');

					if (isLast) {
						setTimeout(() => {
							updateContext(consentHandle, status);
							toast.success(consentStatusText);
							props.history.push({
								pathname: `/consent-status`,
								state: {
									status: consentStatusText,
									statusCode: status === 'ACCEPT' ? 200 : 201,
								},
							});
						}, SUBMITTING_CONSENT_COUNTER);
					} else {
						setTimeout(() => {
							updateContext(consentHandle, status);
							toast.success(consentStatusText);
							setState({ ...state, isDisable: false });
						}, SUBMITTING_CONSENT_COUNTER);
					}
				} else {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
					if (res?.status === 'FAILURE') {
						postMessage('session', 'FAILURE');
					} else if (res?.status === 'ERROR') {
						postMessage('session', 'ERROR');
					}
					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Consent denied',
								statusCode: 20,
							},
						});
					}, 500);
				}
			});
	};

	const handleAcceptFiuMultiple = async () => {
		const consents = consentsContext?.selectedConsents;
		if (consents && consents.length > 0) {
			if (global?.accountRestrictions?.maxAcc) {
				if (
					(state.selectedAccounts?.length || 0) >
					global?.accountRestrictions?.maxAcc
				) {
					toast.error(
						`${t('paymentConsent.messages.selectMax')} ${
							global?.accountRestrictions?.maxAcc
						} ${t('paymentConsent.messages.selectedConsent')}`
					);
					return;
				}
			}
			if (
				areAllArraysEmptyForConsents(
					state.consentSelectedAccounts,
					selectedConsentsState
				)
			) {
				toast.error(t('paymentConsent.error.selectAtleaseOne'));
				return;
		} else if (
			global.redirectAccountRestrictions &&
			!areAllMandatoryRestrictionsSatisfied(
				state.allLinkedAccounts,
				state.matchedRestrictions
			)
		) {
			toast.error(t('paymentConsent.error.linkMandatoryAccounts'));
			return;
			} else {
				let continueApprove = true;
				const consentAccounts = [];

			for (let k = 0; k < consents?.length; k++) {
				let requiredAccountsSelected = [];
				const requiredFI = consents[k].fiTypes;
				// If user clicked "Add More", send user's actual selection
				// Otherwise, filter by restrictions in targeted mode
				const selectedAccounts = (global.redirectAccountRestrictions && !global.userClickedAddMore)
					? filterSelectedAccountsByRestrictions(
							state.consentSelectedAccounts[consents[k].ConsentHandle]
					  )
					: state.consentSelectedAccounts[consents[k].ConsentHandle] || [];
					let fips = selectedAccounts
						.filter((el) => requiredFI.includes(el?.FIType))
						.map((el) => el?.fipId);
					fips = [...new Set(fips)];
					for (let j = 0; j < fips?.length; j++) {
						let withFip = {
							FIP: {
								id: fips[j],
							},
							Accounts: [],
						};
						for (let i = 0; i < selectedAccounts?.length; i++) {
							if (requiredFI.includes(selectedAccounts[i]?.FIType)) {
								if (fips[j] === selectedAccounts[i]?.fipId) {
									let single = {
										accType: selectedAccounts[i]?.accType,
										accRefNumber: selectedAccounts[i]?.accRefNumber,
										maskedAccNumber: selectedAccounts[i]?.maskedAccNumber,
										FIType: selectedAccounts[i]?.FIType,
										fipId: selectedAccounts[i]?.fipId,
										linkRefNumber: selectedAccounts[i]?.linkRefNumber,
										fipName: selectedAccounts[i]?.fipName,
										// Note: restrictions property is excluded as it's only for internal validation
									};
									if (
										!isAccountLinked(
											single,
											withFip.Accounts,
											selectedAccounts[i]?.fipId
										)
									) {
										withFip.Accounts.push(single);
									}
								}
							}
						}
						if (withFip.Accounts.length > 0) {
							requiredAccountsSelected.push(withFip);
						}
					}
					if (requiredAccountsSelected.length === 0) {
						toast.error(t('paymentConsent.error.noRelevantAccSelected'));
						continueApprove = false;
					} else {
						consentAccounts.push({
							ConsentHandle: consents[k].ConsentHandle,
							fiuId: consents[k].FIU.id,
							Accounts: requiredAccountsSelected,
						});
					}
				}
				if (continueApprove) {
					setState({ isDisable: true, disableType: 'ACCEPT' });
					let isLast = false;
					for (let k = 0; k < consentAccounts?.length; k++) {
						if (k === consentAccounts?.length - 1) {
							isLast = true;
						}
						await consentApproveRequest(
							consentAccounts[k].Accounts,
							'ACCEPT',
							consentAccounts[k].ConsentHandle,
							consentAccounts[k].fiuId,
							isLast
						);
					}

					// Calculate total accounts across active consents only
					const totalAccounts = Object.entries(state.consentSelectedAccounts)
						.filter(([consentHandle]) =>
							selectedConsentsState.includes(consentHandle)
						)
						.flatMap(([_, accounts]) => accounts || []).length;

					// Calculate unique accounts from active consents only
					const uniqueAccounts = new Set(
						Object.entries(state.consentSelectedAccounts)
							.filter(([consentHandle]) =>
								selectedConsentsState.includes(consentHandle)
							)
							.flatMap(([_, accounts]) => accounts || [])
							.map(
								(acc) => `${acc.maskedAccNumber}-${acc.FIType}-${acc.accType}`
							)
					).size;

					// Capture analytics for approved consents
					const metrics = {
						totalConsents: consentsAll.length,
						approvedConsents: consentsContext?.selectedConsents.length,
						uniqueAccounts,
						totalAccounts,
						fiTypes: Array.from(
							new Set(state.linkedAccounts.map((acc) => acc.FIType))
						),
						isPurposeIconClicked,
						isAccountInfoIconClicked,
					};
					captureConsentApproved(metrics);
				}
			}
		} else {
			if (global?.institutionType === 'LSP') {
				setOpenDrawer(true);
			} else {
				toast.error(t('paymentConsent.error.noConsentSelected'));
			}
			return;
		}
	};

	const handleDeny = async () => {
		setState({ ...state, isDisable: true });
		let isLast =
			consentsAll.length - consentsAccepted.length - consentsDenied.length === 1
				? true
				: false;
		const consents = consentsContext.consentList;
		for (let k = 0; k < consents.length; k++) {
			if (k === consents.length - 1) {
				isLast = true;
			}
			await consentApproveRequest(
				[],
				'DENY',
				consents[k].ConsentHandle,
				consents[k].FIU.id,
				isLast
			);
		}

		// Calculate total accounts across active consents only
		const totalAccounts = Object.entries(state.consentSelectedAccounts)
			.filter(([consentHandle]) =>
				selectedConsentsState.includes(consentHandle)
			)
			.flatMap(([_, accounts]) => accounts).length;

		// Calculate unique accounts from active consents only
		const uniqueAccounts = new Set(
			Object.entries(state.consentSelectedAccounts)
				.filter(([consentHandle]) =>
					selectedConsentsState.includes(consentHandle)
				)
				.flatMap(([_, accounts]) => accounts)
				.map((acc) => `${acc.maskedAccNumber}-${acc.FIType}-${acc.accType}`)
		).size;

		// Capture analytics for denied consents
		const metrics = {
			totalConsents: consentsAll.length,
			deniedConsents: consentsAll.length,
			uniqueAccounts,
			totalAccounts,
			fiTypes: Array.from(
				new Set(state.linkedAccounts.map((acc) => acc.FIType))
			),
			isPurposeIconClicked,
			isAccountInfoIconClicked,
		};
		captureConsentDenied(metrics);

		consentsContext.updateConsentList([]);
	};
	//-----------------------------------
	const updateAccounts = (el, data) => {
		// Ensure data is an array
		const accountsArray = Array.isArray(data) ? data : [];

		if (accountsArray.includes(el)) {
			const index = accountsArray.indexOf(el);
			accountsArray.splice(index, 1);
		} else {
			accountsArray.push(el);
		}
		return accountsArray;
	};

	const selectUnselectAcc = async (el, consentHandle = null) => {
		// Check if the account is restricted for the current consent
		const currentConsent = consentHandle
			? consentsAll.find((consent) => consent.ConsentHandle === consentHandle)
			: null;

		if (currentConsent && isAccountRestrictedForConsent(el, currentConsent)) {
			// Account is restricted, don't allow selection
			return;
		}

		let data = updateAccounts(el, [...state.selectedAccounts]);
		if (consentHandle) {
			// Ensure consentSelectedAccounts[consentHandle] exists and is an array
			const currentConsentAccounts =
				state.consentSelectedAccounts[consentHandle] || [];
			const consentData = updateAccounts(el, [...currentConsentAccounts]);
			const accounts = { ...state.consentSelectedAccounts };
			accounts[consentHandle] = consentData;
			setState({
				...state,
				selectedAccounts: data,
				consentSelectedAccounts: accounts,
			});
			return;
		}
		setState({ ...state, selectedAccounts: data });
	};
	//-------------------------------------------------------
	//Floating Button logic
	const [unviewedConsents, setUnviewedConsents] = useState(
		consentsAll.length - 1
	);
	const consentListRef = useRef();

	useEffect(() => {
		const lastChildren = [
			...document.getElementsByClassName('lastChildCard'),
		].slice(1);
		const observer = new IntersectionObserver((entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					setUnviewedConsents((prev) => prev - 1);
				}
			}
		});
		for (const child of lastChildren) {
			observer.observe(child);
		}

		return () => {};
	}, []);

	const handleMoreConsentsClick = () => {
		const consentListElement = consentListRef.current;
		if (!consentListElement) return;

		const nextConsentIndex = consentsAll.length - unviewedConsents;
		const nextConsentElement = consentListElement.children[nextConsentIndex];
		nextConsentElement.scrollIntoView({ behavior: 'smooth' });
		nextConsentElement.focus();
	};

	// Effect to automatically unselect restricted accounts
	useEffect(() => {
		const { selectedAccounts, consentSelectedAccounts } =
			removeRestrictedAccountsFromSelection(
				state.selectedAccounts,
				state.consentSelectedAccounts,
				consentsAll,
				state.linkedAccounts
			);

		// Update state if changes were made
		if (
			selectedAccounts.length !== state.selectedAccounts.length ||
			JSON.stringify(consentSelectedAccounts) !==
				JSON.stringify(state.consentSelectedAccounts)
		) {
			setState((prevState) => ({
				...prevState,
				selectedAccounts,
				consentSelectedAccounts,
			}));
		}
	}, [state.linkedAccounts, consentsAll]);

	const toggleSelectAll = () => {
		if (selectedConsentsState?.length < consentsAll.length) {
			setSelectedConsentsState(
				consentsAll.map((a) => {
					return a?.ConsentHandle;
				})
			);
			consentsContext.updateSelectedConsentList(consentsAll.map((a) => a));
			setSelectAll(true);
		} else {
			// un select all for FIU getting consentoptions from config
			if (global.consentOptions) {
				let updatedConsents = [];
				for (const option of global.consentOptions) {
					for (const consent of consentsAll) {
						if (
							option['Purpose.code'] == consent?.Purpose?.code &&
							!option.checkbox
						) {
							consentsContext.updateSelectedConsentList(
								consentsAll.filter((consent) =>
									consentsAll.includes(consent?.ConsentHandle)
								)
							);
							updatedConsents.push(consent.ConsentHandle);
						}
					}
				}
				// Update state once after the loops
				setSelectedConsentsState(updatedConsents);
				setSelectAll(false);
			} else {
				consentsContext.updateSelectedConsentList([]);
				setSelectedConsentsState([]);
				setSelectAll(false);
			}
		}
	};
	const isDarkTheme = props.customDetails?.darkTheme === true;
	useEffect(() => {
		if (props?.updateInitialLoader) {
			props.updateInitialLoader(false);
		}
	}, []);
	return (
		<Box
			sx={{
				fontFamily: props?.customDetails?.fontFamily,
				display: 'flex',
				justifyContent: { xs: 'start', md: 'center' },
				flexDirection: { xs: 'column', md: 'column' },
				minHeight: { xs: 'auto', md: 'auto' },
				alignItems: 'start',
				m: `${!mobileScreen ? '0 3rem' : 'none'}`,
			}}
		>
			<RequestedConsents
				display={'flex'}
				customDetails={props.customDetails}
				consentDetailsList={state?.consentDetailsList}
				selectedConsentsState={selectedConsentsState}
				handleIsActive={selectUnselectConsents}
				selectAll={selectAll}
				toggleSelectAll={toggleSelectAll}
				showSelectAll={showSelectAll}
				{...props}
			/>
			<div
				ref={consentListRef}
				style={{
					display: 'flex',
					flexDirection: 'column',
					// gap: '1rem',
					width: '100%',
				}}
			>
				{consentsAll.map((consent, idx) => (
					<ConsentCardFull
						key={idx}
						customDetails={props.customDetails}
						consentDetails={consent}
						id={idx + 1}
						selectedConsentsState={selectedConsentsState}
						handleIsActive={selectUnselectConsents}
						isMultiConsent={consentsAll?.length > 1}
						isLast={idx === consentsAll.length - 1}
						onInfoClick={handleInfoClick}
					>
						<LinkedAccountsSection
							handleSelect={selectUnselectAcc}
							superState={state}
							selectedConsentsState={selectedConsentsState}
							linkedAccounts={state.uniqueLinkedAccounts}
							customDetails={props.customDetails}
							consentDetails={
								state?.consentDetailsList || global.selectedConsent
							}
							consentHandle={consent?.ConsentHandle}
							selectedAccounts={state.selectedAccounts}
							handleAccept={handleAcceptFiuMultiple}
							handleDeny={handleDeny}
							consent={consent}
							{...props}
							accountRestrictions={computeAccountRestrictions(
								consent,
								state.linkedAccounts
							)}
						/>
					</ConsentCardFull>
				))}
				<FloatingButton
					numberOfUnviewedConsents={unviewedConsents}
					handleClick={handleMoreConsentsClick}
				/>
				<div>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							width: '100%',
						}}
					>
						<Box
							sx={{
								bottom: mobileScreen ? '0rem' : '1.875rem',
								right: mobileScreen ? '0rem' : '0rem',
								backgroundColor: mobileScreen
									? theme.palette.background.paper
									: 'none',
								gap: mobileScreen ? '1rem' : '1.25rem',
								width: mobileScreen
									? '100vw'
									: global.alternativeText?.DENY_BTN
									? '40%'
									: '20%',
								marginRight: mobileScreen ? 0 : '40px !important',
								flexWrap: 'wrap',
								...linkedAccountsSectionStyles.buttonGroup,
							}}
						>
							<Button
								variant="outlined"
								fullWidth={mobileScreen}
								color="error"
								onClick={() => setDeny(true)}
								sx={{
									flex: 1,
									// Override the global button styles for Deny button
									backgroundColor: isDarkTheme
										? 'transparent !important'
										: '#ffffff !important',
									color: '#E94B4B !important',
									borderColor: '#E94B4B !important',
									'&:hover': {
										backgroundColor: 'rgba(233, 75, 75, 0.04) !important',
										borderColor: '#E94B4B !important',
									},
								}}
							>
								{t('common.buttons.deny')}
							</Button>
							<Button
								variant="contained"
								fullWidth={mobileScreen}
								disabled={unviewedConsents > 0}
								onClick={() => {
									handleAcceptFiuMultiple();
								}}
								sx={{
									backgroundColor:
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#e0e0e0'
											: props.customDetails?.ctaBackgroundColor ??
											  props.customDetails?.primaryColor,
									color:
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#666666'
											: `${
													props.customDetails?.ctaTextColor ||
													(isDarkTheme ? '#000000' : '#FFFFFF')
											  } !important`,
									flex: 1,
									border: `1px solid ${
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#cccccc'
											: props?.customDetails?.ctaBorderColor ??
											  props?.customDetails?.primaryColor
									}`,
									'&:hover': {
										backgroundColor:
											global.sdkOptions?.isAcceptDisabled === 'true' &&
											isAcceptDisabled
												? '#e0e0e0'
												: props.customDetails?.ctaHoverPrimaryColor ??
												  props.customDetails?.primaryColor,
									},
								}}
							>
								{t('common.buttons.accept')}
							</Button>
							{mobileScreen ? <WhyShare {...props} /> : null}
						</Box>
					</Box>
				</div>
			</div>
			<DialogBox
				open={deny}
				handleClose={handleClose}
				title={t('paymentConsent.dialog.denyConsent.title')}
				subTitle={t('paymentConsent.dialog.denyConsent.subtitle')}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
			>
				<DenyConsent
					handleCancel={() => setDeny(false)}
					{...props}
					handleDeny={handleDeny}
					isDarkTheme={isDarkTheme}
				/>
			</DialogBox>
			<Drawer
				open={openDrawer}
				setOpen={setOpenDrawer}
				medWidth={0}
				closeBtnTop={'1rem'}
				customDetails={props?.customDetails}
			>
				<FiuList
					selectUnselectConsents={selectUnselectConsents}
					handleAccept={handleAcceptFiuMultiple}
					selectedConsentsState={selectedConsentsState}
					linkedAccountsSelected={state.consentSelectedAccounts}
				/>
			</Drawer>
			{!mobileScreen && (
				<Box sx={{ m: '1rem auto' }}>
					<WhyShare {...props} />
				</Box>
			)}
		</Box>
	);
}

export default PaymentConsent;
